import { getCheckToken } from 'services/api/user/checktoken';
import { postPasswordReset } from 'services/api/user/passwordReset';
import { RESET_PASSWORD_IS_LOADING } from '../actions/login';
import { HIDE_MODAL_PASSWORD, SHOW_NEW_PASSWORD_FORM, SUCCESS_PASSWORD_CHANGED } from 'actions/forgot-password';

export const resetPasswordIsLoading = isLoading => ({
  type: RESET_PASSWORD_IS_LOADING,
  payload: isLoading,
});

export const resetPassword = ({
  password,
  confirm_password,
  token,
}) => dispatch => {
  dispatch(resetPasswordIsLoading(true));
  const params = {
    password_new: password,
    password_rep: confirm_password,
    token,
  };
  return postPasswordReset(params)
    .then(result => {
      const { status } = result;
      dispatch(resetPasswordIsLoading(false));
      if (status && parseInt(status, 10) !== 0) return Promise.reject(result);
      localStorage.removeItem('changePasswordModal');
      dispatch({ type: SUCCESS_PASSWORD_CHANGED });
      return Promise.resolve(result);
    })
    .catch(err => {
      dispatch(resetPasswordIsLoading(false));
      return Promise.reject(err);
    });
};

export const checkToken = token => dispatch => {
  dispatch(resetPasswordIsLoading(true));
  return getCheckToken(token)
    .then(result => {
      const { status } = result;
      dispatch(resetPasswordIsLoading(false));
      if (status && parseInt(status, 10) !== 0) return Promise.reject(result);
      return Promise.resolve(result);
    })
    .catch(err => {
      dispatch(resetPasswordIsLoading(false));
      return Promise.reject(err);
    });
};

export const hideModalPassword = () => ({
  type: HIDE_MODAL_PASSWORD,
});

export const showPasswordFormModal = () => ({
  type: SHOW_NEW_PASSWORD_FORM,
});
